module.exports = __webpack_public_path__ + "img/personal.a92a171e.svg";